import CardSection from "../CardSection/cardSection";
import { useTranslation } from "react-i18next";
import { getGlobalSearchQueryURL } from '../../constants'

export default function MediaKitsSection({ page = 1, rows = 12, onTotal }) {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language || "en-us").toLowerCase();
  return (
    <CardSection
      tabLabel="Media Kits"
      apiUrl={`${getGlobalSearchQueryURL}?q=*&locale=${locale}&fl=title,description,primaryImage,documentType,documentTypeDate,url,cqTagsIdName_s&fq=documentType:Media%20Kits&groupBy=documentType,yearMonth,cqTagsName_s&sort=documentTypeDate&startDate=2018-01-01T00:00:00Z&endDate=2030-07-17T09:33:03Z
`}
      onTotal={onTotal}
      page={page}
      rows={rows}
    />
  );
}
